(function() {
    'use strict';

    angular
        .module('dashboard')
        .factory('dashboardCsrService', dashboardCsrService);

    function dashboardCsrService($http,
                                 $q,
                                 resourceService,
                                 dateUtil,
                                 dashboardBookingService) {
        const csrStatus = {
            1: 'CSRUNALLOCATED',
            2: 'CSRINPROGRESS',
            3: 'CSRSTATUSCOMPLETED',
            4: 'CSRAWAITINGRESPONSE',
            5: 'CSRAWAITINGACKNOWLEDGEMENT'
        };

        const csrStatusClass = {
            1: 'csr-unallocated',
            2: 'csr-inprogress',
            3: 'csr-completed',
            4: 'csr-awaiting-response',
            5: 'csr-waiting-acknowledge'
        };

        const baseCsrUrl = '/api2/csr/customer';

        const service = {
            getCSRStatus,
            getCSRStatusCode,
            getCSRSummary,
            getCSRDetail,
            getCsrCategories,
            createCsr,
            getAllCSRs,
            htmlifyLineBreaks,
            getCsrStatusClass,
            getConvertationFromCsr,
            addCsrToBooking,
            getSenderTitle,
            submitMessage
        };

        function getAllCSRs() {
            return $http.get(`${baseCsrUrl}?domainId=${TRPCONFIG.Domain.DomainId}`,
                { ignoreErrors: true }).then(res => {
                    return _.map(res.data, csr => _enrichCSR(csr));
                });
        }

        function getCSRStatus(id) {
            return resourceService.get(csrStatus[id]);
        }

        function getCSRStatusCode(id) {
            return angular.copy(csrStatus[id]);
        }

        function getCsrStatusClass(id) {
            return angular.copy(csrStatusClass[id]);
        }

        function getCSRSummary(bookingId) {
            return $http.get(`${baseCsrUrl}/booking/${bookingId}`).then(_parseCSRSummary);
        }

        function getCSRDetail(bookingId) {
            return $http.get(`${baseCsrUrl}/${bookingId}`).then(r => _enrichCSR(r.data));
        }

        function _parseCSRSummary(res) {
            const csr = {
                completed: [],
                pending: []
            };
            res.data.forEach(item => {
                _enrichCSR(item);
                if (item.Status === 3) {
                    csr.completed.push(item);
                } else {
                    csr.pending.push(item);
                }
            });
            csr.pending = _.orderBy(csr.pending, csr => csr.lastUpdated, 'desc');

            return csr;
        }

        function _enrichCSR(item) {
            item.conversation = getConvertationFromCsr(item);
            item.openQuestion = _.find(item.Questions, q => !q.Answer);
            item.lastUpdated = _.reduce(item.conversation, (updatedDate, c) => {
                return (dateUtil.compareDates(c.date, updatedDate) === 1) ? c.date : updatedDate;
            }, item.CreatedDate);
            item.StatusResource = getCSRStatus(item.Status);
            item.AddNoteAllowed = item.Status !== 3;
            return item;
        }

        function getCsrCategories(bookingType, bookingId) {
            return $http.get(`/api2/csr/categories?${$.param({
                BookingType: bookingType,
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                BookingId: bookingId
            })}`).then(result => {
                return result.data;
            });
        }

        function createCsr(csr, bookingId, mobileTel) {
            return $http.post(baseCsrUrl,
                {
                    DomainId: TRPCONFIG.Domain.DomainId,
                    BookingId: bookingId,
                    CategoryId: csr.Category.Id,
                    TextAlerts: csr.TextAlerts,
                    Subject: csr.Subject,
                    Text: csr.Text,
                    MobileTel: mobileTel
                }).then(res => {
                    return res.data;
                });
        }

        function _answerToQuestion(questionId, answerText) {
            return $http.post(`${baseCsrUrl}/question/${questionId}/answer`, {
                AnswerText: answerText
            });
        }

        function _addLogToCsr(log, csrId) {
            return $http.post(`${baseCsrUrl}/${csrId}/log`, log);
        }

        function submitMessage(csr) {
            const question = _.find(csr.conversation, c => c.openQuestion);
            if (question && (question.questionId > -1)) {
                return _answerToQuestion(question.questionId, csr.newMessage).then(() => {
                    csr.conversation.push({
                        text: htmlifyLineBreaks(csr.newMessage),
                        createdByCustomer: true
                    });
                    csr.newMessage = null;
                    question.openQuestion = null;
                    return true;
                });
            }

            if (csr.AddNoteAllowed) {
                return _addLogToCsr({ Text: csr.newMessage }, csr.CsrId).then(() => {
                    csr.conversation.push({
                        text: htmlifyLineBreaks(csr.newMessage),
                        createdByCustomer: true
                    });
                    csr.newMessage = null;
                    return true;
                });
            }

            return $q.when(false);
        }

        function htmlifyLineBreaks(text) {
            return text ? text.replace(/<br\/>\s*\n|\n\s*<br\/>/g, '<br/>').replace(/\n/g, '<br/>') : text;
        }

        function getConvertationFromCsr(csr) {
            const openQuestion = _.find(csr.Questions, q => !q.Answer);
            const sortedCoversation = _.orderBy(_.concat(csr.Questions, csr.Logs), c => c.QuestionDate || c.CreatedDate);

            const initialText = {
                text: htmlifyLineBreaks(csr.Text),
                date: csr.CreatedDate,
                createdByCustomer: !csr.AgentName,
                agentName: csr.AgentName
            };

            const conversations = _.flatMap(sortedCoversation, c => {
                if (c.QuestionDate) {
                    //c is a question and answer
                    if (c.Answer) {
                        const q = {
                            text: htmlifyLineBreaks(c.QuestionText),
                            date: c.QuestionDate,
                            agentName: c.AgentName
                        };
                        const a = {
                            text: htmlifyLineBreaks(c.Answer),
                            date: c.AnswerDate,
                            createdByCustomer: true
                        };
                        return [q, a];
                    }
                } else {
                    // c is a log
                    const l = {
                        text: htmlifyLineBreaks(c.Text),
                        date: c.CreatedDate,
                        createdByCustomer: c.CreatedByCustomer,
                        agentName: c.AgentName
                    };
                    return l;
                }
            });
            if (openQuestion) {
                const q = {
                    text: htmlifyLineBreaks(openQuestion.QuestionText),
                    date: openQuestion.QuestionDate,
                    questionId: openQuestion.Id,
                    openQuestion: true,
                    agentName: openQuestion.AgentName
                };
                conversations.push(q);
            }
            const validConversation = _.filter(conversations, c => c != null);
            if (initialText.text != null && initialText.text.length > 0) {
                validConversation.unshift(initialText);
            }
            return validConversation;
        }

        function getSenderTitle(conversation) {
            return conversation.createdByCustomer ?
                resourceService.get('CSRYOUASKED') :
                String.format(resourceService.get('CSRAGENTASKED'), conversation.agentName);
        }

        function addCsrToBooking(trips) {
            service.getAllCSRs().then(csrs => {
                const allCsrs = _.orderBy(csrs, 'lastUpdated', 'desc');
                _.each(trips, tr => {
                    _.each(tr.Bookings, bk => {
                        bk.csr = {
                            message: _getCsrMessage(bk.BookingId, allCsrs),
                            statusClass: _getCsrStatusClass(bk.BookingId, allCsrs)
                        };
                    });
                });
            });
        }

        function _getCsrMessage(bookingId, allCsrs) {
            const csr = _.find(allCsrs, ['BookingId', bookingId]);
            let resourceVal = csr ? resourceService.get(`MYB${service.getCSRStatusCode(csr.Status)}`) : '';
            const actionPath = dashboardBookingService.translateActionLink(
                'dashboard/csr/{{BookingId}}', { BookingId: bookingId }
            );
            if (csr) {
                if (csr.Status === 4) {
                    const openQuestion = _.find(csr.Questions, q => !q.Answer);
                    resourceVal = String.format(decodeURI(resourceVal), openQuestion.AgentName, actionPath);
                } else {
                    resourceVal = String.format(decodeURI(resourceVal), actionPath);
                }
            }
            return resourceVal;
        }

        function _getCsrStatusClass(bookingId, allCsrs) {
            const csr = _.find(allCsrs, ['BookingId', bookingId]);
            return csr ? service.getCsrStatusClass(csr.Status) : '';
        }

        return service;
    }
})();
